import React from 'react';
import styled from 'styled-components';
import { VehicleModelProps } from './cargo-model';
import { VehiclePart } from '../../enums';
import VehicleHood from './vehicle-hood';
import VehicleWindow from './vehicle-window';
import VehicleCabin from './vehicle-cabin';
import VehicleRoof from './vehicle-roof';

class VehicleBody extends React.Component<VehicleModelProps, any> {
  render() {
    const { className, ...other } = this.props;

    return (
      <div className={className}>
        <VehicleHood part={VehiclePart.Front} {...other} />
        <VehicleWindow {...other} />
        <VehicleCabin {...other} />
        <VehicleRoof {...other} />
        <VehicleHood part={VehiclePart.Rear} {...other} />
      </div>
    );
  }
}

const StyledVehicleBody = styled(VehicleBody)`
  width: 10em;
  position: relative;
  margin: 0 1.5em -2.5em;
`;

export default StyledVehicleBody;
